import classNames from 'classnames';
import { isEmpty } from 'lodash';
import React from 'react';
import { isProductType529 } from 'src/utils/funds/funds-utility';
import {
  APP_BUY_TRANSACTION,
  APP_SELL_TRANSACTION,
  IRA_AUTOMAX_TRANSACTION,
  BUY_TRANSACTION,
  COLLEGE_CONTRIBUTE_TRANSACTION,
  COLLEGE_DISTRIBUTE_TRANSACTION,
  COLLEGE_EXCHANGE_TRANSACTION,
  EXCHANGE_TRANSACTION,
  RECURRING_BUY_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION,
  SELL_TRANSACTION,
  transactionType,
  AUTOMATIC_SELL_TRANSACTION,
  ROTH_CONVERSION,
  QCD_TRANSACTION,
} from 'src/utils/transactions-util';
import { AutoExchangeFundNotes } from './AutoExchangeFundNotes';
import BuyFundNotes from './BuyFundNotes';
import CollegeContributeFundNotes from './CollegeContributeFundNotes';
import CollegeDistributeFundNotes from './CollegeDistributeFundNotes';
import CollegeExchangeFundNotes from './CollegeExchangeFundNotes';
import ExchangeFundNotes from './ExchangeFundNotes';
import styles from './FundNotes.module.scss';
import RecurringBuyFundNotes from './RecurringBuyFundNotes';
import SellFundNotes from './SellFundNotes';
import { FundNoteListProps } from './types';
import { AutoSellFundNotes } from './AutoSellFundNotes';
import RothConversionFundNotes from './RothConversionFundNotes';
import QCDFundNotes from './QCDFundNotes';

const expandFundNotes = (event) => {
  event.target.parentNode.classList.add(styles['fund-note-expanded']);
};
// @ts-ignore
export const AutoSellWrappedNotes = ({ fund }) => (
  <>
    <SellFundNotes fund={fund} />
    <AutoSellFundNotes fund={fund} />
  </>
);
export const ExchangeConditionalNotes = ({ fund }) =>
  isProductType529(fund.productType) ? (
    <CollegeExchangeFundNotes fund={fund} />
  ) : (
    <ExchangeFundNotes fund={fund} />
  );

export const BuildNotes = ({ type, fund }) => {
  switch (type) {
    case BUY_TRANSACTION:
    case APP_BUY_TRANSACTION:
      return <BuyFundNotes fund={fund} />;
    case RECURRING_BUY_TRANSACTION:
    case IRA_AUTOMAX_TRANSACTION:
      return <RecurringBuyFundNotes fund={fund} />;
    case SELL_TRANSACTION:
    case APP_SELL_TRANSACTION:
      return <SellFundNotes fund={fund} />;
    case AUTOMATIC_SELL_TRANSACTION:
      return <AutoSellWrappedNotes fund={fund} />;
    case EXCHANGE_TRANSACTION:
      return <ExchangeConditionalNotes fund={fund} />;
    case RECURRING_EXCHANGE_TRANSACTION:
      return <AutoExchangeFundNotes fund={fund} />;
    case COLLEGE_CONTRIBUTE_TRANSACTION:
      return <CollegeContributeFundNotes fund={fund} />;
    case COLLEGE_DISTRIBUTE_TRANSACTION:
      return <CollegeDistributeFundNotes fund={fund} />;
    case COLLEGE_EXCHANGE_TRANSACTION:
      return <CollegeExchangeFundNotes fund={fund} />;
    case ROTH_CONVERSION:
      return <RothConversionFundNotes fund={fund} />;
    case QCD_TRANSACTION:
      return <QCDFundNotes fund={fund} />;
    default:
      return <></>;
  }
};

const FundNotes: React.VFC<FundNoteListProps> = ({ fund }) =>
  isEmpty(fund) || isEmpty(fund.notes) ? (
    <React.Fragment key="emptyFundNotes" />
  ) : (
    <div
      className={classNames(
        styles['fund-notes-list'],
        `fund-notes-${fund.agreementID}`
      )}
    >
      {/* TODO: change this to <Route>s so that we're not relying on the window object */}
      <BuildNotes fund={fund} type={transactionType()} />
      <a
        className={classNames(
          'college-branded-link',
          'exclude',
          styles['fund-notes-more-link']
        )}
        onClick={expandFundNotes}
      >
        more notes...
      </a>
    </div>
  );

export default FundNotes;
